import { IntentType } from '../types';
import { useLanguage } from '../contexts/LanguageContext';

interface IntentSelectorProps {
  value: IntentType | '';
  onChange: (value: IntentType) => void;
}

export function IntentSelector({ value, onChange }: IntentSelectorProps) {
  const { t } = useLanguage();

  const options: { value: IntentType; label: string }[] = [
    { value: 'buy', label: t.form.intent.options.buy },
    { value: 'sell', label: t.form.intent.options.sell },
  ];

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as IntentType)}
      className="intent-select"
      required
    >
      <option value="" disabled>
        {t.form.intent.placeholder}
      </option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
